<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData
            :coaching="coachingData"
            :calculatedUnits="calculatedUnitsData"/>

        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
          <div class="row mt-3 ms-5">
            <div class="col-lg-3 col-md-4 col-sm-12 mb-4">
              <BaseCheckbox
                  v-model="formData.careContact"
                  label="Betreuungsvertrag"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.costCommitment"
                  label="Kostenzusage"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.houseRule"
                  label="Hausordnung"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.healthQuestionnaire"
                  label="Gesundheitsfragebogen"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.dataProtection"
                  label="Datenschutz"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.declarationOfAssignment"
                  label="Abtretungserklärung"
                  :labelPosition="'right'"/>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-2">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalService from '@/api/Portal/AssistedLivingCoaching';
import coachingService from '@/api/Unemployed/AssistedLivingCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/AssistedLivingCoaching/CoachingOverviewData.vue';
import Menu from '@/views/App/Portal/AssistedLivingCoaching/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState      = piniaUserStore();
const piniaCurrentUser    = computed(() => piniaUserState.currentUser.user);
const { t }               = useI18n();
const route               = useRoute();
const coachingData        = ref('');
const calculatedUnitsData = ref('');
const isLoaded            = ref(false);
const isSubmitting        = ref(false);
const coachingId          = +route.params.id;

const formData = ref({
  coachingId: null,
  careContact: '',
  costCommitment: '',
  houseRule: '',
  healthQuestionnaire: '',
  dataProtection: '',
  declarationOfAssignment: '',
});

async function submitForm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;

    await portalService.submitIntroductoryDocuments(formData.value);

    await getDocumentsData();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function geCoachingData() {
  try {
    CloseToast();
    const { data } = await coachingService.getAssistedLivingCoaching(+coachingId);

    coachingData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getDocumentsData() {
  try {
    const { data } = await portalService.getIntroductoryDocuments(+coachingId);
    formData.value = { ...data.data };

    const { data: calculatedUnits } = await coachingService.getCalculatedUnits(+coachingId);
    calculatedUnitsData.value       = calculatedUnits.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    geCoachingData(),
    getDocumentsData(),
  ]);

  isLoaded.value = true;
});
</script>
<style scoped>

</style>